import debouncePromise from 'debounce-promise';

import validation from '../../../services/validation';

import {
  setBSCenterAddress,
  suggestionChange,
  addressSelect,
  validateAddress,
  resetValidation,
  geoObjectProcessed,
  getSuggestionsForInput,
  geocodeStart,
} from '../../../../blocks/segments/address/address.events';

import { trackAddressInputSelect } from '../tracking/tracking';
import { trackAddressSuccess } from './tracking';
import { resetFormValidityState } from './utils/form-validation';
import { updateAddressUserInputValidityState } from './utils/geo-accuracy-error';
import { isAddressCached } from './utils/address-cache';
import { setGeoCache } from './utils/geo-cache';

import template from './user-input.jade';
import './typeahead-item.tpl.jade';
import './typeahead-popup.tpl.jade';


const validationSearchMessages = {
  required: 'Введите адрес вручную или передвиньте маркер на карте.',
  // eslint-disable-next-line max-len
  needLocation: '<b>Не удалось определить точный адрес.</b> Попробуйте подвинуть метку на объект или введите адрес заново.',
  needAddress: 'Укажите адрес',
  needHouse: '<b>Не указан дом!</b> Пожалуйста, укажите номер дома. Если у дома нет номера - укажите ближайший.',
  // eslint-disable-next-line max-len
  needStreet: '<b>Не указана улица!</b> Проверьте, правильно ли вы указали улицу. Попробуйте подвинуть метку на карте, чтобы адрес определился автоматически.',
  // eslint-disable-next-line max-len
  needCity: '<b>Не указан населённый пункт!</b> Необходимо указать населённый пункт. Если нужного населённого пункта нет в справочнике - выберите ближайший крупный.',
  notFound: '<b>Адрес не найден.</b> Если нужного адреса нет в справочнике - выберите ближайший',
  // eslint-disable-next-line max-len
  serverError: '<b>Ошибка на сервере!</b> Попробуйте ввести адрес повторно, или подвинуть метку на карте. Если проблема остаётся - попробуйте подать объявление позже',
};

export default angular
  .module('cian.addForm.userInput', [])
  .directive('cianAfAddressUserInput', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'geoSelectorService', 'bsCenterService', 'addFormLayoutService', '$window', '$scope', '$rootScope', '$q',
      '$timeout', 'geoService', 'adStateService', 'analyticsService',
      // eslint-disable-next-line func-names
      function (
        geoSelectorService, bsCenterService, addFormLayoutService, $window, $scope, $rootScope, $q, $timeout,
        geoService, adStateService, analyticsService
      ) {
        const isOfferEditing = !!this.ad.id;

        const isNewOffer = adStateService.isNewOffer;

        let previousInput;
        this.geoObjectProcessed = false;
        this.delayedSuggestionQuery = false;

        this.isAddressValidated = false;

        let validationQueries = 0;

        this.validationSearch = validation(this.form, 'geo.userInput', validationSearchMessages);

        this.isValidationRequired = () => {
          if (this.form['geo.userInput']) {
            // TODO pristine проставляется при вводе названия ЖК
            // и из-за этого поле становится как бы невалидным
            // Чтобы это поправить, надо понимать в любой момент времени, изменялся ли адрес
            const firstLoadOfUserInput = this.form['geo.userInput'].$pristine;

            return firstLoadOfUserInput || this.validationSearch.invalid();
          }

          return false;
        };

        this.getDefiniteAddressType = () => {
          let type = null;

          if (this.ad.geo.address && this.ad.geo.address[0]) {
            type = this.ad.geo.address[this.ad.geo.address.length - 1].type;
          }

          return type;
        };

        this.isValidationWarning = () => {
          return this.form['geo.userInput'].$error.serverError;
        };

        const doValidateAddress = geoObject => {
          if (!this.form['geo.userInput']) {
            return;
          }

          const firstLoadOfUserInput = this.form['geo.userInput']
            ? this.form['geo.userInput'].$pristine
            : false;

          validationQueries--;

          if (validationQueries || !this.form['geo.userInput']) {
            return;
          }

          const definedAddress = (geoObject && firstLoadOfUserInput)
            ? geoObject.geoType
            : this.getDefiniteAddressType();

          this.isAddressValidated = true;
          this.form['geo.userInput'].$setDirty();
          this.form['geo.userInput'].$setTouched();

          resetFormValidityState(this.form);

          const isCurrentAddressCached = isAddressCached((this.ad.geo.userInput || '').trim(), this.geoCache);

          if (!isCurrentAddressCached) {
            setGeoCache({
              address: (this.ad.geo.userInput || '').trim(),
              geoObject,
              geoCache: this.geoCache,
            });
          }

          updateAddressUserInputValidityState({
            form: this.form,
            geoObject,
            definedAddress,
            $rootScope,
            isNewOffer,
            isAddressCached: isCurrentAddressCached,
          });

          const isAddressValid =
            !this.geoObjectProcessed &&
            this.isAddressValidated &&
            !this.validationSearch.invalid();

          if (isAddressValid && !isCurrentAddressCached) {
            trackAddressSuccess(isNewOffer);
          }

          $rootScope.$broadcast('geo.address.validated', isAddressValid);
        };

        this.validateAddress = (geoObject, sync) => {
          validationQueries++;

          if (sync) doValidateAddress(geoObject);
          else $timeout(() => doValidateAddress(geoObject), 300);
        };

        this.geoCache = {};

        let ymaps;

        geoSelectorService.ready(_ymaps => {
          ymaps = _ymaps;
          if (this.delayedSuggestionQuery) {
            this.getSuggestions(this.delayedSuggestionQuery, true);
          }
        });

        const getAddressSuggestions = (query, options) =>
        ymaps.suggest(`${/([Рр]оссия[, ])/.test(query) ? '' : 'Россия, '}${query}`, options);
        const getBSSuggestions = query => bsCenterService.suggest(query);

                /**
         * Преобразовывает строку с координатами квадрата window.addFormState.geo.bbox
         * в двумерный массив чисел этих координат и создает объект параметров для саджеста
         * @return Object { boundedBy: Number[][] }
         */
        const getBoundaryBox = () => {
          if (geoService.userGeo && geoService.userGeo.bbox) {
            const bboxStringsArr = String(geoService.userGeo.bbox).split(',');
            const bboxIntArr = bboxStringsArr.map(item => Number(item));
            const boundaryBox = {
              boundedBy: [
                [bboxIntArr[1], bboxIntArr[0]],
                [bboxIntArr[3], bboxIntArr[2]],
              ],
            };

            return boundaryBox;
          }

          return {};
        };

        /**
         * Получить элементы для саджеста, в отдельных категориях коммерции
         * возвращаем комбинированый список - адреса и БЦ/ТЦ
         * Саджест в любом случае пишет адрес в ad.geo.userInput, но при выборе БЦ
         * мы иницииуруем доп. действия в методе selectAddress
         * @param queryText
         * @param firstLoad
         * @return {*|Promise.<TResult>}
         */
        // todo: kravets check delayedSuggestionQuery and firstload
        this.getSuggestions = (queryText, firstLoad) => {
          if (!ymaps || !queryText) {
            return $q.when([]);
          }

          const suggests = {
            address: getAddressSuggestions(queryText, { ...getBoundaryBox(), results: 10 }),
          };

          if (bsCenterService.isBSCategory(this.ad.category)) suggests.bsCenter = getBSSuggestions(queryText);

          return $q.all(suggests)
            .then(results => {
              this.emitSuggestionChange(results.address, firstLoad);

              const suggestions = [];

              if (results.address && Array.isArray(results.address)) {
                const addressSuggestions = results.address.map(addressResult => {
                  const suggest = { ...addressResult };

                  suggest.suggestType = 'address';
                  suggest.displayName = suggest.displayName.replace(/, Россия/i, '');

                  return suggest;
                });

                suggestions.push(...addressSuggestions);
              }

              if (results.bsCenter && Array.isArray(results.bsCenter)) {
                const bsCenterSuggestions = results.bsCenter.map(bsCenterResult => {
                  const suggest = { ...bsCenterResult };

                  suggest.suggestType = 'bsCenter';
                  suggest.value = suggest.geo.fullAddress;

                  return suggest;
                });

                suggestions.push(...bsCenterSuggestions);
              }

              return suggestions;
            });
        };

        this.getSuggestionsDebounced = debouncePromise(this.getSuggestions, 600);

        this.emitSuggestionChange = (items, firstLoad) => {
          if (items && items.length && this.suggestion !== items[0].displayName) {
            this.suggestion = items[0].displayName;
            $rootScope.$emit(suggestionChange, this.suggestion, firstLoad);
          }
        };

        const emitUserInputChanged = () => {
          if (previousInput !== this.ad.geo.userInput) {
            previousInput = this.ad.geo.userInput;
            $rootScope.$emit(addressSelect);
          }
        };

        /**
         * Адрес выбран из саджеста
         * @param value значение инпута - geo.userInput
         * @param suggestItem весь элемент саджеста
         * @param event
         */
        this.selectAddress = (value, suggestItem) => {
          trackAddressInputSelect(analyticsService.adAnalyticsCategory);

          if (suggestItem.suggestType === 'bsCenter') {
            bsCenterService.fillBSCenterData(suggestItem);
            $rootScope.$emit(setBSCenterAddress, suggestItem.geo, true, () => {
              // лэйаут может быть еще не включен, если выбирая БЦ из саджеста,
              // мы находимся в регионе где нет короткой ФП
              addFormLayoutService.setLayout();
              if (addFormLayoutService.isShortLayout) {
                addFormLayoutService.setRevertValues();
                addFormLayoutService.setShortForm();
              }
            });
          } else {
            emitUserInputChanged();
          }
        };

        this.onFocus = () => {
          if ($window.ca) {
            $window.ca('eventSite', {
              name: 'oldevent',
              category: isOfferEditing ? 'Edit_ad' : 'New_ad',
              action: 'GEO',
              label: 'address_input_click',
            });
          }
        };

        // todo: blur срабатывает раньше чем тайпахед пишет в модель,
        // если ввести адрес и быстро убрать фокус - ad.geo.userInput будет
        // неактуальным (проблема была актуальна до короткой ФП)
        this.onBlur = () => {
          emitUserInputChanged();
        };

        this.resetValidation = (valid = false) => {
          this.isAddressValidated = valid;
          if (valid) {
            this.form['geo.userInput'].$setDirty();
            this.form['geo.userInput'].$setTouched();
          } else {
            this.form['geo.userInput'].$setPristine();
            this.form['geo.userInput'].$setUntouched();
          }
          this.form['geo.userInput'].$setValidity('needHouse', true);
          this.form['geo.userInput'].$setValidity('needStreet', true);
          this.form['geo.userInput'].$setValidity('needCity', true);
          this.form['geo.userInput'].$setValidity('notFound', true);
          this.form['geo.userInput'].$setValidity('serverError', true);
          this.form['geo.userInput'].$setValidity('needAddress', true);
          $rootScope.$broadcast('geo.address.validated', valid);
        };

        $scope.$watch(() => this.ad.category, category => {
          this.showHeading = category === 'newBuildingFlatSale';
          this.title = bsCenterService.isBSCategory(category) ? 'Адрес или название бизнес-центра' : 'Адрес';
        });

        const detachValidateAddress = $rootScope.$on(
          validateAddress,
          (event, geoObject, sync) => this.validateAddress(geoObject, sync)
        );
        const detachResetValidation = $rootScope.$on(resetValidation, (event, valid) => this.resetValidation(valid));
        const detachGeoObjectProcessed = $rootScope.$on(geoObjectProcessed, (event, status) => {
          this.geoObjectProcessed = status;
          this.form['geo.userInput'].$setValidity('serverError', !status);
        });
        const detachGetSuggestions = $rootScope.$on(
          getSuggestionsForInput,
          (event, query) => { this.delayedSuggestionQuery = query; }
        );
        const geocodeStartListener = $rootScope.$on(geocodeStart, () => {
          /**
           * В начале запроса к geocode устанавливаем $pending статус поля, для ошибки serverError
           * Статус поля $pending будет удален после валидации
           * https://docs.angularjs.org/api/ng/type/ngModel.NgModelController#$setValidity
           * Это позволяет блокировать кнопку отправки на период запроса и валидации адреса,
           * Считаем что валидация будет мгновенная, после получения данных
           */
          this.form['geo.userInput'].$setValidity('serverError', undefined);
        });

        $scope.$on('$destroy', () => {
          detachValidateAddress();
          detachResetValidation();
          detachGeoObjectProcessed();
          detachGetSuggestions();
          geocodeStartListener();
        });
      },
    ],
    controllerAs: 'userInput',
    template,
  }))
  .name;
